exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".detail-title[data-v-462ea0d8]{font-size:16px;font-weight:500;color:#333}.title-margin[data-v-462ea0d8]{margin:40px 0 20px}.detail-record[data-v-462ea0d8]{padding:20px;background-color:#fff;border-radius:16px}.record-success[data-v-462ea0d8]{margin-left:20px;color:#15cd85}.record-failure[data-v-462ea0d8]{margin-left:20px;color:var(--xty-red-color)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-462ea0d8&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentBox/EquipmentBoxDetail.vue
// module id = 514
// module chunks = 0